/**
 * useFadeIn — Intersection Observer ile scroll fade-in animasyonu
 * Kullanim: ref'i section'a ver, class otomatik eklenir
 */
import { useEffect, useRef } from 'react'

export function useFadeIn<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    el.classList.add('lp-fade-section')

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('lp-visible')
          observer.unobserve(el)
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return ref
}
